import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import banglore from "../Images/banglore.jpg"
import bangloreOffice1 from "../Images/Bangalore main (1).png"
import manglore from "../Images/Mangalore (1).png"
import shivamogga from "../Images/shivamogga.jpg"
import davanagere from "../Images/Davanagere branch.png"
import raichur from "../Images/raichur.jpg"
import hubli from "../Images/hubli.png"
import Haveri from "../Images/sliderNew/haveriweb.png"
import channai from "../Images/channai.jpg"
import Hybd from "../Images/sliderNew/hyderabadweb.png"
import Hybd2 from "../Images/sliderNew/hyderabad2.jpg"
import tumkur from "../Images/Tumkur (1).png"
import logo from "../Images/LOGO (2).png"
import mysuru from "../Images/Mysuru (1).jpeg"

export default function CardSlider() {
  const branches = [
    {
      name: "RAICHUR",
      locality: "Gunj Road",
      address: "12-10-18/1A, 1st Floor, Gunj Road, Near Vaikuntam Complex, Raichur - 584101",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n6ehPvVnbcuqR1TjlLBTdMJrgHFGA:1780563900160&kgmid=/g/11w9149n6m&q=Sristar+Gold+Company+-+Gold+Buyers+in+Raichur&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=209b120e70eee863&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: raichur
    },
    {
      name: "HUBLI",
      locality: "Tirumala Trade Centre",
      address: "Shop No 40, Ground Floor, Tirumala Trade Centre, Neeligin Rd, Deshpande Nagar, Hubballi, Karnataka 580029",
      mapLink: "https://www.google.com/maps/place/SRISTAR+GOLD+COMPANY/@15.357199,75.1310656,17z/data=!3m1!4b1!4m6!3m5!1s0x3bb8d7a28ebc47b7:0x8c849cca35e02a74!8m2!3d15.357199!4d75.1310656!16s%2Fg%2F11w975x8c9?entry=ttu",
      img: hubli
    },
    {
      name: "HAVERI",
      locality: "Hosamani Siddappa Circle",
      address: "Gudagar Complex, 1st Floor Hosamani Siddappa Circle Beside KGP, Jewelry Haveri - 581110",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n7EJ6GYr8u1nooDkG00RyW8h9Xbnw:1780563893818&kgmid=/g/11vz8109cq&q=SRISTAR+GOLD+COMPANY&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=ec3acba93d364258&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: Haveri
    },
    {
      name: "HYDERABAD",
      locality: "Vajra Residency",
      address: "203 A Block 1st Floor, Musheerabad Main Road, Bakaram, Kavadiguda, Hyderabad, Telangana 500080",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n4XTW6ttak85hklxkj3lXAMN879Dw:1780563899563&kgmid=/g/11ldwnjdrn&q=Sristar+Gold+Company+-+Gold+Buyers+in+Hyderabad&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=dcb652e890f730b2&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: Hybd
    },
    {
      name: "HYDERABAD",
      locality: "Mallapur",
      address: "#7 No 5-1-121/2, HCK Complex Mallapur Main Road, Annapurna Colony, Uppal Tp District, Hyderabad - 500076",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n4XTW6ttak85hklxkj3lXAMN879Dw:1780563899563&kgmid=/g/11ldwnjdrn&q=Sristar+Gold+Company+-+Gold+Buyers+in+Hyderabad&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=dcb652e890f730b2&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: Hybd2
    },
    {
      name: "BENGALURU",
      locality: "18th Cross, Malleshwaram",
      address: "280/1, Anniamma Arcade, Sampige Road, 18th Cross Rd, Malleshwaram, Bengaluru, Karnataka 560003",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n5Vtby4BJ12dIhCLErosaqEzb88kA:1780563895714&kgmid=/g/11q4z2gb38&q=SriStar+Gold+Company&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=518fd72067fa7c7d&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: banglore
    },
    {
      name: "BENGALURU",
      locality: "Margosa Road",
      address: "2nd Floor, Margosa Building, 13th Cross Road, Margosa Rd, opp. City Union Bank, Malleshwaram, Bengaluru, Karnataka 560003",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n5V6G4YNKuWV0T2eg8oXsWgC7wnkw:1780563696766&kgmid=/g/11npsdjq1g&q=Sristar+Gold+Company+-+Margosa+Road&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=33c5819ae86e4978&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: bangloreOffice1
    },
    {
      name: "CHENNAI",
      locality: "Mount Road",
      address: "No 9, JV White House, 1st Floor, Blackers Road, Anna Salai, Chennai, Tamil Nadu 600002",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n4A2h1FmXq2PRwiKxNb9O4Sm-ltyg:1780563896622&kgmid=/g/11rscd3gtz&q=Sristar+Gold+Company&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=0a06888a737e78c3&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: channai
    },
    {
      name: "SHIVAMOGGA",
      locality: "NT Road",
      address: "89/1 - 1066/1 28, NT Rd, opp. URDU SCHOOL, R.M.L Nagar, Milagatta, Shivamogga, Karnataka 577202",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n5FicBLFBTtGXvpbNvOzTpXb9U1HQ:1780563896018&kgmid=/g/11vywv92l6&q=SriStar+gold+company&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=bab76e9855ffb162&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: shivamogga
    },
    {
      name: "MANGALORE",
      locality: "Pioneer Complex",
      address: "D/No - 20-3-293-26, Maidan Rd, near State Bank, Uppinagadi Village, Mangaluru, Karnataka 575001",
      mapLink: "https://www.google.com/maps/place/SriStar+Gold+Company+-+Mangalore/@12.8696988,74.8453076,17z/data=!3m1!4b1!4m6!3m5!1s0x3ba35b30cbab81cb:0x76c49c1eebd93a5b!8m2!3d12.8696988!4d74.8453076!16s%2Fg%2F11kjz98wsy?entry=ttu",
      img: manglore
    },
    {
      name: "DAVANAGERE",
      locality: "PB Road",
      address: "150/3A, PB Rd, opposite Reliance Smart Bazar, KB Extension, Davangere, Karnataka 577002",
      mapLink: "https://www.google.com/maps/place/Sristar+Gold+Company+-+Davanagere/@14.4715423,75.926418,17z/data=!3m1!4b1!4m6!3m5!1s0x3bba2515fc9279fd:0xce8c17d22e85f3d1!8m2!3d14.4715423!4d75.926418!16s%2Fg%2F11w8xd4g4l?entry=ttu",
      img: davanagere
    },
    {
      name: "TUMKUR",
      locality: "Honnavar Hwy",
      address: "Honnavar Hwy, opposite Tumkur University College, Opposite University College, Venkatesh Rao Colony, Tumakur, Karnataka 572103",
      mapLink: "https://www.google.com/maps/place/SriStar+Gold+Company+-+Tumkuru/@13.3365651,77.1223788,17z/data=!3m1!4b1!4m6!3m5!1s0x3bb02dad3794a4a3:0xe8f6c8b327c49449!8m2!3d13.3365651!4d77.1223788!16s%2Fg%2F11z1_wv_lm?entry=ttu",
      img: tumkur
    },
    {
      name: "MYSURU",
      locality: "Sunnadakeri 4th cross",
      address: "No. 912 Susheel Building, 2nd floor, Sunnadakeri 4th cross, N S Road, Opp Nakshtra Complex, Mysuru, 570024",
      mapLink: "https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n60bBedVWeFmH7meUrtPHPHZQQBig:1780563903837&kgmid=/g/11st67z_3j&q=Sristar+Gold+Company+-+Mysuru&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=32f67d2a21be27b5&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1",
      img: mysuru
    }
  ];

  return (
    <>
      <section className='multi-slider-secition'>
        <div className='container '>
          <div className='sub-hading'>
            <h2>Branches</h2>
            <div className='swiper-cont'>
              <Swiper
                slidesPerView={4}
                spaceBetween={20}
                centeredSlides={false}
                pagination={{
                  clickable: false,
                }}
                navigation={false}
                modules={[Pagination, Autoplay]}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: true,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  480: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 4
                  }
                }}
                className="mySwiper-container"
              >
                {branches.map((branch, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="gold-card">
                      <div className="gold-card-image">
                        <img src={branch.img} alt={branch.name} className={branch.name === "DAVANAGERE" || branch.name === "MANGALORE" || branch.name === "MYSURU" ? "contain-img" : ""} />
                      </div>
                      <div className="gold-icon">
                        <img src={logo} alt="Sristar Logo" />
                      </div>
                      <div className="gold-card-content">
                        <h3>{branch.name}</h3>
                        <h5>{branch.locality}</h5>
                        <div className="card-divider"></div>
                        <p>{branch.address}</p>
                        <a
                          href={branch.mapLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="direction-btn text-decoration-none"
                        >
                          GET DIRECTIONS →
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
